import { useEffect } from 'react';

import useGetProfilePicture from 'hooks/useGetProfilePicture';

import './ProfilePicture.scoped.scss';

const ProfilePicture = ({ userId }) => {
  const { profilePicture, getProfilePicture } = useGetProfilePicture();
  useEffect(() => {
    getProfilePicture(userId);
  }, []);
  return <img src={profilePicture} />;
};

export default ProfilePicture;
